export default __webpack_public_path__ + "static/media/kitchen3-after3-768w.627048e8.webp";